export const TEXT_ALLERGENS = [
  'Arachides',
  'Crustacés',
  'Fruits à coque',
  'Gluten',
  'Lait',
  'Lupin',
  'Mollusques',
  'Moutarde',
  'Oeuf',
  'Poisson',
  'Sésame',
  'Soja',
  'Sulfites',
];
